import React from 'react'

import { Page } from 'app/templates'

import { styled, theme } from 'ui/styles'
import { Text } from 'ui/components'
import { breakpoints, useDimensions } from 'shared/dimensions'
import { TECH_STACK_TEAM, TECH_STACK_TEAM_ADAPTIVE } from 'app/data/teams'
import { Team as TeamList } from 'app/features/modals/molecules/team'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 0 64px 56px;
  z-index: 100;
  backdrop-filter: blur(12px);
  background: rgba(42, 61, 87, 0.95);

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 0 32px 56px;
  }
`

const Content = styled.div`
  max-width: 850px;
`

const HeaderWrapper = styled.div`
  padding-top: 56px;
  margin-bottom: 24px;

  display: flex;
  flex-direction: column;
  & > div:first-child {
    margin-bottom: 12px;
  }

  :not(:first-of-type) {
    padding-top: 64px;
  }
`

export const Languages: React.FC = () => {
  const { isDesktop } = useDimensions();
  
  return (
    <Page>
      <Wrapper>
        <Content>
          <HeaderWrapper>
            <Text variant="h3" color={theme.palette.white}>
              Используемые языки программирования и инструменты разработки
            </Text>
            <Text bold variant="t3" color={theme.palette.white}>
              В рамках деятельности в области информационных технологий мы используем следующие языки программирования, программное обеспечение и инструменты для разработки программного обеспечения.
            </Text>
          </HeaderWrapper>
          {isDesktop ? <TeamList team={TECH_STACK_TEAM} /> : <TeamList team={TECH_STACK_TEAM_ADAPTIVE} />}
        </Content>
      </Wrapper>
    </Page>
  )
}
